module.exports = __webpack_public_path__ + "static/media/crew-dragon.1a3415ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/crew-dragon.jpg
// module id = 320
// module chunks = 0